import { render } from "./BusinessFirePrint.vue?vue&type=template&id=6d877c80&scoped=true"
import script from "./BusinessFirePrint.vue?vue&type=script&lang=js"
export * from "./BusinessFirePrint.vue?vue&type=script&lang=js"

import "./BusinessFirePrint.vue?vue&type=style&index=0&id=6d877c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d877c80"]])

export default __exports__